import "leaflet-area-select";
import 'leaflet-contextmenu';
import 'leaflet-contextmenu/dist/leaflet.contextmenu.css';
import "leaflet-lasso";
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/leaflet.markercluster.js';
import 'leaflet/dist/leaflet.css';
import React, { forwardRef, useCallback, useEffect, useImperativeHandle, useRef, useState } from 'react';
import {
    MapContainer, TileLayer,
} from 'react-leaflet';
import zoomInSvg from "../../../../assets/images/zoom_in_map.svg";
import zoomOutSvg from "../../../../assets/images/zoom_out_map.svg";
import ClusterComponent from './Features/ClusterComponent';
import CustomZoomControl from './Features/CustomZoomControl';
import LassoSelection from './Features/LassoSelection';
import LayersComponent from './Features/LayersComponent';
import RectangularSelection from './Features/RectangularSelection';
import dataStorageService from "../../../../shared/common-utilities/services/DataStorageService";
// import { MapContainer, TileLayer } from 'leaflet-xserver'

let storageService = dataStorageService();
const userData = JSON.parse(storageService.getLocalStorageData('userData'))

const LeafletMap = forwardRef(({ data, zoom, center, sendDataToParent, selectionRectangular, selectionLasso, coordinatesData, selectionCluster }, ref) => {
    const mapRef = useRef(null);
    // const map = L.map('map');
    const clusterRef = useRef(null);
    const [clustered, setClustered] = useState(selectionCluster)
    const [url, setUrl] = useState(`${process.env.REACT_APP_PTV_URL}${process.env.REACT_APP_PTV_MAP_TYPE}/v1/image-tiles/{z}/{x}/{y}?apiKey=${userData?.ptvDeveloperToken}&layers=${process.env.REACT_APP_DEFAULT_LAYERS}`)

    useImperativeHandle(ref, () => ({
        onPlanButtonsOptimizeRoute(ptrId) {
            clusterRef.current.onPlanButtonsOptimizeRoute(ptrId);
        },
        onDropEvent(layerId) {
            clusterRef.current.onDropEvent(layerId);
        },
        mapRef
    }));


    // useEffect(() => {
    //     L.tileLayer.xserver(
    //         'https://s0{s}-xserver2-europe-test.cloud.ptvgroup.com/services/rs/XMap/renderMap',
    //         {
    //             requestExtension: {
    //                 "storedProfile": "gravelpit",
    //                 "requestProfile": {
    //                     "featureLayerProfile": {
    //                         "themes": [{
    //                             "enabled": true,
    //                             "id": "PTV_TruckAttributes"
    //                         }]
    //                     }
    //                 },
    //                 "resultFields": {
    //                     "featureThemeIds": ["PTV_TruckAttributes"]
    //                 }
    //             },
    //             username: 'xtok',
    //             password: window.token,
    //             subdomains: '1234',
    //             maxZoom: 22,
    //             pane: 'tilePane'
    //         }).addTo(map);
    // }, [])



    useEffect(() => {
        // console.log(selectionRectangular)
        // console.log(selectionLasso)
    }, [selectionRectangular, selectionLasso])

    // useEffect(() => {
    // }, [selectionRectangular, selectionLasso])

    const zoomIn = useCallback(() => {
        if (mapRef?.current) {
            mapRef.current.setZoom(mapRef.current.getZoom() + 1);
        }
    }, []);

    const zoomOut = useCallback(() => {
        if (mapRef?.current) {
            mapRef.current.setZoom(mapRef.current.getZoom() - 1);
        }
    }, []);

    const childHandler = (params) => {
        sendDataToParent(params);
    }

    const ChangeMapAppearance = (params) => {
        eval(params)
    }

    const menuItemsList = [
        { index: 0, text: 'Zoom in', callback: zoomIn, icon: zoomInSvg },
        { index: 1, separator: true }, { index: 2, text: 'Zoom out', callback: zoomOut, icon: zoomOutSvg },
    ];

    const mapEventsHandler = useCallback((mapInstance) => {
        // mapRef.current = mapInstance;
    }, []);

    // console.log("Leaflet - Rerender")
    // console.log(selectionRectangular)
    // console.log(selectionLasso)

    return (
        <div className="map-three" draggable='true'>
            <MapContainer
                ref={mapRef}
                center={center}
                zoom={zoom}
                minZoom={2}
                maxZoom={18}
                scrollWheelZoom={true}
                fullscreenControl
                contextmenu
                contextmenuItems={menuItemsList}
                whenReady={(e) => mapEventsHandler(e.target)}
                dragging={true}
                tap={false}
                zoomControl={false}
            >
                <TileLayer 
                    // attribution='©2023, PTV Group, HERE'
                    url={url} //&style=amber
                />


                {/* plan on map features component */}
                <LayersComponent sendDataToParent={ChangeMapAppearance} />
                <RectangularSelection enableRactangular={selectionRectangular} sendDataToParent={childHandler} />
                <LassoSelection enableLasso={selectionLasso} sendDataToParent={childHandler}/>
                <CustomZoomControl />
                <ClusterComponent ref={clusterRef} data={data} selectionCluster={clustered} sendDataToParent={childHandler} />
            </MapContainer>
        </div>
    );
});

export default LeafletMap;